import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { useToggle } from '@app/hooks'
import { fetchQueryOptions } from '@app/utils'

import type { FetchedOptionsParams, FetchedOptionsReturn } from './types'

export const useFetchedOptions = <OptionType, ResponseResultType>({
  defaultOptions,
  queryOptions
}: FetchedOptionsParams<OptionType, ResponseResultType>): FetchedOptionsReturn<OptionType> => {
  const queryClient = useQueryClient()
  const loadingToggle = useToggle()

  const [fetchedOptions, setFetchedOptions] = useState<OptionType[] | undefined>()

  useEffect(() => {
    const handleFetchOptions = async (): Promise<void> => {
      if (queryOptions) {
        loadingToggle.setToggled()

        const fetchedOptions = await fetchQueryOptions<OptionType, ResponseResultType>(queryClient, queryOptions)

        setFetchedOptions(fetchedOptions)

        loadingToggle.setUntoggled()
      } else {
        setFetchedOptions(defaultOptions)
      }
    }

    handleFetchOptions()
  }, [defaultOptions, queryOptions])

  return { fetchedOptions, isLoading: loadingToggle.value }
}
